module.exports = __webpack_public_path__ + "static/media/Logo-NexoYoga-RGB.28ffacce.png";